import React, { useEffect, useState } from "react";
import ChangelogModal from "./ChangelogModal";

const ChangelogModalWrapper = (props) => {
  const [changelog, setChangelog] = useState("");
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    // ใช้ AbortController เพื่อ cancel request เมื่อ component unmount
    const abortController = new AbortController();
    const changelogUrl = process.env.PUBLIC_URL + "/CHANGELOG.md";

    fetch(changelogUrl, { signal: abortController.signal })
      .then((res) => {
        if (!res.ok) {
          throw new Error(`HTTP error! status: ${res.status}`);
        }
        return res.text();
      })
      .then((text) => {
        // เช็คว่า component ยัง mounted อยู่หรือไม่ก่อน setState
        if (!abortController.signal.aborted) {
          setChangelog(text);
          setLoading(false);
        }
      })
      .catch((error) => {
        // ไม่แสดง error ถ้า request ถูก abort
        if (error.name !== 'AbortError' && !abortController.signal.aborted) {
          console.log("📝 Using fallback changelog data");
          setChangelog("");
          setLoading(false);
        }
      });

    // Cleanup function: cancel request เมื่อ component unmount
    return () => {
      abortController.abort();
    };
  }, []);

  if (loading) {
    console.log("⏳ Loading changelog...");
  }

  return (
    <ChangelogModal
      open={props.open}
      onClose={props.onClose}
      changelog={changelog}
    />
  );
};

export default ChangelogModalWrapper;
